export function canAttachFileToExam (statusId, allowedStatuses, releasedStatus, allowAfterReportedExam) {
  return allowedStatuses.includes(statusId) ||
    (statusId === releasedStatus && allowAfterReportedExam === true)
}

export function buildSuccessUploadStatusUrl (fileId, attachmentType) {
  const attachmentTypeQuery = attachmentType != null
    ? `&AttachmentType=${encodeURIComponent(attachmentType)}`
    : ''

  return `/core/Administrator/Exams/SetSuccessUploadStatus?examFileId=${fileId}${attachmentTypeQuery}`
}
